import Login from '@/components/modules/auth/login';
import Profile from '@/components/modules/auth/profile-v2';
import ResetPassword from '@/components/modules/auth/ResetPassword';

const login = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login',
    },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      title: 'Profile',
    },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      filter: false,
      header: true,
    },
  },
];

export default login;
